import { render, staticRenderFns } from "./DownloadStock.vue?vue&type=template&id=5981075c"
import script from "./DownloadStock.vue?vue&type=script&lang=js"
export * from "./DownloadStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports